import { render } from "./FitDataTable.vue?vue&type=template&id=56a1ff71&scoped=true&lang=pug"
import script from "./FitDataTable.vue?vue&type=script&lang=js"
export * from "./FitDataTable.vue?vue&type=script&lang=js"

import "./FitDataTable.vue?vue&type=style&index=0&id=56a1ff71&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a1ff71"]])

export default __exports__